import { render, staticRenderFns } from "./WeMedia.vue?vue&type=template&id=b5aab5ec&scoped=true"
import script from "./WeMedia.vue?vue&type=script&lang=js"
export * from "./WeMedia.vue?vue&type=script&lang=js"
import style0 from "./WeMedia.vue?vue&type=style&index=0&id=b5aab5ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5aab5ec",
  null
  
)

export default component.exports